// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_from(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

function unwrap_fragment_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["IncomingMessageStatus"]);
}

let fragmentConverter = {"__root":{"status":{"u":"fragment_status"},"sentAt":{"b":""},"from_Agent":{"f":""},"from":{"u":"fragment_from"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_from: unwrap_fragment_from,
  fragment_status: unwrap_fragment_status
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function incomingMessageStatusState_decode($$enum) {
  if ($$enum === "NEW" || $$enum === "READ" || $$enum === "PAST_MESSAGE") {
    return $$enum;
  }
}

let incomingMessageStatusState_fromString = incomingMessageStatusState_decode;

function membershipStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let membershipStatusV5_fromString = membershipStatusV5_decode;

let Utils = {
  incomingMessageStatusState_decode: incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: incomingMessageStatusState_fromString,
  membershipStatusV5_decode: membershipStatusV5_decode,
  membershipStatusV5_fromString: membershipStatusV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageConversationMessagesMessage_message",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "from",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "membershipStatus",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentProfilePhoto_agent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent"
            }
          ],
          "type": "Agent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sentAt",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              "action": "NONE"
            }
          ],
          "type": "IncomingMessageStatus",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationMessageImages_conversationMessage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationMessageFiles_conversationMessage"
    }
  ],
  "type": "ConversationMessageV5",
  "abstractKey": null
};
})());

let wrap_fragment_from = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_status = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_from = unwrap_fragment_from;
exports.wrap_fragment_from = wrap_fragment_from;
exports.unwrap_fragment_status = unwrap_fragment_status;
exports.wrap_fragment_status = wrap_fragment_status;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
